import { createStore } from 'zustand'

type ReportStoreType = {
  classroomId: string
  learningPlanLessonId: string | undefined
}

const initialState: ReportStoreType = {
  classroomId: '',
  learningPlanLessonId: undefined
}

const useStore = createStore<ReportStoreType>(() => initialState)

export const reportStore = {
  setClassroomId: (classroomId: string): void => {
    useStore.setState({ classroomId })
  },

  setLearningPlanLessonId: (learningPlanLessonId: string | undefined): void => {
    useStore.setState({ learningPlanLessonId })
  },

  getReportContext: (): string => {
    const state = useStore.getState()

    return JSON.stringify(state)
  },

  useStore
}
